import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Avatar } from 'material-ui';
import { ListItem } from 'material-ui/List';
import CheckCircleIcon from 'material-ui/svg-icons/action/check-circle';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { ACHIEVEMENT_PAGE } from '../../../constants/routes';
import withTranslation from '../../../hoc/withTranslation';
import style from '../../../styles/styles';

class AchievementItem extends React.Component {

    static propTypes = {
        achievement: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
    };

    // Render

    renderPicture() {
        let achievement = this.props.achievement;
        if (achievement.picture && achievement.picture.length > 0) {
            return <Avatar src={achievement.picture} style={style.image.cover} />;
        }
        return <Avatar icon={<CheckCircleIcon />} />;
    }

    render() {
        const {
            achievement,
            app,
        } = this.props;
        return (
            <Link
                to={
                    ACHIEVEMENT_PAGE
                        .replace(':appId', app.id)
                        .replace(':achievementId', achievement.id)
                }
            >
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderPicture()}
                    primaryText={
                        <div>
                            {
                                achievement.name ||
                                this.props.t('module.gamification.untitled_achievement')
                            }
                        </div>
                    }
                    disableKeyboardFocus={true}
                >
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(withTranslation(AchievementItem));



// WEBPACK FOOTER //
// src/components/achievement/AchievementItem/AchievementItem.js